module.exports = __webpack_public_path__ + "static/media/buy_insurance_btn_icon.14329c2b.svg";